import React from 'react';

export default function PurchaseBillsGeneral({ setError, error, setForm, form }) {
	return <div>Development In Progress</div>;
}
